export default __webpack_public_path__ + "static/image_08-cc0084a14cc088bd9ce7781ded61c5fa.png";